export default __webpack_public_path__ + "static/exp5-942ff2864f25c3224d008f9706d4851c.jpg";